import { ArtifactGenerator } from './ArtifactGenerator';

export class PRDGenerator extends ArtifactGenerator {
  generatePrompt(): string {
    return `You are an expert Product Requirements Document (PRD) writer.
I will provide a set of product ideas below, and I'd like you to create a comprehensive PRD.

Context and Ideas:

${this.getIdeaHierarchy()}

Please create a detailed PRD with the following structure:

# Product Requirements Document

## 1. Executive Summary
- Product Vision
- Problem Statement
- Target Users/Customers
- Key Features and Benefits
- Success Metrics

## 2. Product Overview
- Product Description
- User Personas
- Use Cases
- User Journey Maps
- Market Analysis
- Competitive Analysis

## 3. Functional Requirements
- Core Features (detailed descriptions)
- User Interactions
- System Behaviors
- Business Rules
- Data Requirements

## 4. Non-Functional Requirements
- Performance Requirements
- Security Requirements
- Scalability Requirements
- Reliability Requirements
- Compatibility Requirements
- Regulatory Requirements

## 5. User Interface
- Design Guidelines
- UI Components
- Navigation Flow
- Wireframes/Mockups Description
- Accessibility Requirements

## 6. Technical Architecture
- System Components
- Data Flow
- Integration Points
- Security Architecture
- Deployment Requirements

## 7. Implementation Plan
- Development Phases
- Dependencies
- Timeline
- Resource Requirements
- Risk Assessment

## 8. Testing Requirements
- Test Strategy
- Test Cases Overview
- Performance Testing
- Security Testing
- User Acceptance Criteria

## 9. Launch Plan
- Launch Strategy
- Marketing Requirements
- Support Requirements
- Training Requirements
- Success Metrics

## 10. Future Considerations
- Product Roadmap
- Scalability Plans
- Future Features
- Maintenance Plans

Please ensure:
1. Each section is detailed and specific
2. All requirements are clear and testable
3. Technical details are precise but understandable
4. Dependencies and risks are clearly identified
5. The document maintains a professional, clear tone
6. Use markdown formatting for better readability
7. Include relevant details from the provided ideas and their context

Generate the complete PRD now, maintaining professional language and clear structure.`;
  }

  protected getIdeaHierarchy(): string {
    return this.ideas.map(idea => {
      return `### ${idea.content}\n${idea.children.map(child => `- ${child.content}`).join('\n')}`;
    }).join('\n\n');
  }
}
